import { Component, OnInit, signal, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GameService } from '@app/game/game.service';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { AssetsService } from '@app/shared/services/assets.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-rate-modal',
  templateUrl: './rate-modal.component.html',
  styleUrls: ['./rate-modal.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule, NavigationButtonComponent],
})
export class RateModalComponent implements OnInit {
  rateModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private assetsService = inject(AssetsService);
  private logger = inject(LoggerService);
  private gameService = inject(GameService);

  starsArray = [1, 2, 3, 4, 5];
  heartsArray = [1, 2, 3];
  rateValue: number = 0;
  stars: HTMLElement[] = [];
  gameIcon: object;
  showThankYouModal = signal(false);

  componentDestroy: () => Observable<unknown>;

  ngOnInit(): void {
    this.assetsService.gamesVersion$.pipe(takeUntil(this.componentDestroy())).subscribe({
      next: (versions) => {
        const url = this.assetsService.getGameIconUrlLegacy(this.rateModalData.data.gameId, versions);
        this.gameIcon = { 'background-image': `url('${url}')` };
      },
      error: (error) => this.logger.error(error),
    });
  }

  rate(rate: number): void {
    this.rateValue = rate;

    for (let i = 0; i < this.starsArray.length; i++) {
      this.stars.push(document.getElementById('star-' + i));

      if (i < this.rateValue) {
        this.stars[i].classList.add('star-filled');
      } else {
        this.stars[i].classList.remove('star-filled');
      }
    }
  }

  rateButton(): void {
    this.gameService.rateGame(this.rateModalData.data.gameId, this.rateValue).subscribe();
    this.showThankYouModal.set(true);

    setTimeout(() => {
      this.closeModal();
    }, 2000);
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(NonPersistedModalName.RateModalComponent, ModalType.View, this.rateModalData)
    );
  }
}
